import React from "react";
import Icon from '@ant-design/icons';

const UploadDoneSVG = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="74" height="70" viewBox="0 0 74 70" fill="currentColor">
        <g>
            <path style={{fill:'#BEBEBE'}} d="M30.7,52.5c0-5.7,1.9-11.3,5.5-15.7h-2.7c-7.7,0-14-6.3-14-14c0,0,0,0,0,0V5.2c0-1.8,0.3-3.6,1-5.2h-15
                C2.6,0,0.3,2.3,0.2,5.2c0,0,0,0,0,0v59.5c0,2.9,2.4,5.2,5.3,5.3h32.2C33.2,65.3,30.7,59,30.7,52.5"/>
            <path style={{fill:'#BEBEBE'}} d="M52.5,24.3L32,3.7c-2-2-3.7-1.3-3.7,1.5v17.5c0,2.9,2.4,5.2,5.3,5.3H51c0.9,0.1,1.8-0.2,2.5-0.8
                C54,26.5,53.7,25.4,52.5,24.3"/>
            <path style={{fill:'#02A574'}} d="M56.3,35c-9.7,0-17.5,7.8-17.5,17.5S46.6,70,56.3,70s17.5-7.8,17.5-17.5S65.9,35,56.3,35
                L56.3,35z M64.8,49.3l-9.5,9.5c-0.8,0.9-2.2,0.9-3,0.1c0,0,0,0-0.1-0.1l-4.4-4.4c-0.9-0.8-0.9-2.2,0-3.1c0,0,0,0,0,0
                c0.9-0.9,2.2-0.9,3.1,0l2.9,2.9l8-8c0.9-0.9,2.2-0.9,3.1,0C65.6,47.1,65.6,48.4,64.8,49.3C64.8,49.3,64.8,49.3,64.8,49.3L64.8,49.3
                z"/>
        </g>
    </svg>
  )

  const UploadDoneIcon = props => <Icon component={UploadDoneSVG} {...props} />;

  export default UploadDoneIcon;